type PropertySelectorFn<T> = (obj: T) => any;
export enum SortOrder {
  Asc = 1,
  Desc = -1
}
type SortFn = (left, right: any, order?: SortOrder) => number;

type SortDefinitionBuilder<T> = (sortBuilder: SortBuilder<T>) => SortDefinition<T>;
type SortDefinitionBuilder2<T> = (sortBuilder: SortBuilder<T>) => SortDefinition<T>[];



function nullSort(left, right) {
  if (left != null && right != null) {
    return 0
  }
  return (left == null ? 1 : -1)
}

function padTo2Digits(num: number) {
  return num.toString().padStart(2, '0');
}
function dateAsIso8601(date: Date) {
  return [date.getFullYear(),
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
  ].join('-')
}

function isString(value) {
  return value == null || typeof value == 'string'
}

export class Sorter<T> {
  constructor(public sortFn = (left, right, order = SortOrder.Asc) => 0) {}
  pipe(...fn: SortDefinition<T>[]): Sorter<T>  {
    this.sortFn =(left, right) => {
      let eq = 0;
      const fns = [...fn].reverse()
      while (eq == 0 && fns.length>0) {
        const next = fns.pop()
        eq = next.sort(next.propertySelector(left), next.propertySelector(right))
      }
      return eq
    }
    return this;
  }

  orderBy(...tris: (SortDefinitionBuilder<T>)[]): Sorter<T> {
    return this.pipe(...tris.map(b => b(new SortBuilder<T>())))
  }

  // orderBy(builder: (SortDefinitionBuilder2<T>)): Sorter<T> {
  //   return this.pipe(...builder(new SortBuilder<T>()))
  // }

  execute(array: T[]) {
    return array.sort(this.sortFn)
  }
}

export interface SortDefinition<T> {
  propertySelector: PropertySelectorFn<T>;
  sort: SortFn;
  order: SortOrder
}

export class SortBuilder<T> {
  string(propertySelector: PropertySelectorFn<T>, order: SortOrder = SortOrder.Asc): SortDefinition<T> {return new StringSort(propertySelector, order)}
  number(propertySelector: PropertySelectorFn<T>, order: SortOrder = SortOrder.Asc): SortDefinition<T> {return new NumberSort(propertySelector, order)}
  date(propertySelector: PropertySelectorFn<T>, order: SortOrder = SortOrder.Asc): SortDefinition<T> {return new DateSort(propertySelector, order)}
  custom(propertySelector: PropertySelectorFn<T>, sort: SortFn, order: SortOrder = SortOrder.Asc): SortDefinition<T> {return new CustomSort(propertySelector, sort, order)}
  null(propertySelector: PropertySelectorFn<T>): SortDefinition<T> {
    return new CustomSort(propertySelector, nullSort)
  }
}

export class StringSort<T> implements SortDefinition<T> {
  constructor(public propertySelector: PropertySelectorFn<T>, public order = SortOrder.Asc){}
  sort = (left: string, right: string): number => {
    if (!(isString(left)) || !(isString(right))) {throw Error('Une des colonnes n’est pas un string -> tri impossible')}
    const ns = nullSort(left, right)
    if (ns != 0) {return ns}
    return (left || '').localeCompare(right) * this.order
  }
}

export class CustomSort<T> implements SortDefinition<T> {
  constructor(public propertySelector: PropertySelectorFn<T>, public sort: SortFn, public order = SortOrder.Asc){}
}


export class NumberSort<T> implements SortDefinition<T> {
  constructor(public propertySelector: PropertySelectorFn<T>, public order = SortOrder.Asc){}
  sort = (left: number, right: number): number => {
    const ns = nullSort(left, right)
    if (ns != 0) {return ns}
    return (left - right) * this.order
  }
}

export class DateSort<T> implements SortDefinition<T> {
  constructor(public propertySelector: PropertySelectorFn<T>, public order: SortOrder = SortOrder.Desc){}
  sort = (left: Date, right: Date): number => {
    const ns = nullSort(left, right)
    if (ns != 0) {return ns}
    return (new Date(left).getTime() - new Date(right).getTime()) * this.order
  }
}




